/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcCloseLargeThin({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M19.46 4.54a.65.65 0 0 1 0 .92L12.92 12l6.54 6.54a.65.65 0 0 1-.919.92l-6.54-6.54-6.54 6.54a.65.65 0 0 1-.92-.92l6.54-6.54-6.54-6.54a.65.65 0 0 1 .92-.92L12 11.08l6.54-6.54a.65.65 0 0 1 .92 0"
        clipRule="evenodd"
      />
    </svg>
  );
}
export default IcCloseLargeThin;
